import { sqliteTable, text, integer, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// departments — แผนก (Department)
// ============================================================================
export const departments = sqliteTable("hr_departments", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  name: text("name").notNull(),
  parentId: text("parent_id"), // tree structure — references self
  isActive: integer("is_active").notNull().default(1),
  // Audit columns
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedBy: text("updated_by"),
  updatedAt: text("updated_at").notNull(),
  deletedBy: text("deleted_by"),
  deletedAt: text("deleted_at"),
}, (table) => ({
  dept_company_idx: index("dept_company_idx").on(table.companyId, table.isActive),
}));

// Type exports
export type Department = typeof departments.$inferSelect;
export type NewDepartment = typeof departments.$inferInsert;
